import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import axios from "axios";
import { Toasts } from "../../toasts";
import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";
import TablaConsultaDeudaGenral from "./tablaConsultaDeudaGeneral";
import TablaActualizarDeuda from "./tablaActualizarDeuda";
import TablaVerificacion from "../actividadEconomica/tablaVerificaciones";
import TablaSolicitudSolvencia from "./tablaSolicitudesSolvencias";
import TablaImpresionSolvencia from "./tablaImpresionSolvencias";
import TablaClasificadorMultas from "./tablaClasificadorMultas";
import TablaAsignarMulta from "./multas";
import ImpModalCaja from "../caja/modalImpCaja";
import { ImprimirEstadoFinancieroPresupuesto } from "../../presupuesto/modalImprimeEstadofinanciero";
import { ImpDeudaGeneralActiEco } from "../actividadEconomica/ImpDeudaGeneral";
import { ImpDeudaGeneralInm } from "../inmueblesUrbanos/impDeudaGeneralInm";
import { ImpporDeuda } from "../propagandaypublicidad/modalImpPpDeuda";
import TablaActualizarDeuda2 from "./tablaActualizarDeuda2";
import ImgGestionComercial from "../../../imagenes/fd_gestion_comercial_b.png";
import TablaConsultaGeneralDeudas from "./tablaConsultaDeudaGeneral";
import AnalisisModuloGestionCom from "./AnalisisModuloGestionCom";
import ModalImprimirPagosRechazados from "./ModalImprimirPagosRechazados";
import GraficasActividad from "./GraficasActividad";
import ModalIngresosActividad from "./ModalIngresosActividad";
function MenuPrincipalGestionComercial() {
  const { user } = useContext(AuthContext);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [mostrarCaja, setMostrarCaja] = useState(false);
  const [mostrarPresu, setMostrarPresu] = useState(false);
  const [mostrarInmu, setMostrarInmu] = useState(false);
  const [mostrarActi, setMostrarActi] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [idefiscal] = useState(localStorage.getItem("idefiscal"));
  const [aniofiscal] = useState(localStorage.getItem("efiscalanio"));

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  let el;

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
      var nanio = [];
      var aini = parseInt(obj.anioactu) - 7;
      var afin = parseInt(obj.anioactu);
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: aini + i });
      }
    } else {
    }
  }, []);

  window.onkeydown = function (event, index) {
    if (event.which === 119) {
      if ((el = document.getElementById("wrapper"))) {
        el.classList.toggle("toggled");
      }
    }
  };
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const [tabla, setTabla] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      tabla.toString() === "20" ||
      tabla.toString() === "23" ||
      tabla.toString() === "24"
    ) {
      setMostrarCaja(true);
    } else if (tabla.toString() === "21") {
      setMostrarPresu(true);
    } else if (tabla.toString() === "25") {
      setMostrarActi(true);
    } else if (tabla.toString() === "26") {
      setMostrarInmu(true);
    }
  }, [tabla]);

  const itemCobranzas = {
    title: "Cobranzas",
    icon: "fa fa-pen me-2",
    drop: [
      {
        title: "Cargar Conceptos de Ingresos",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 1,
      },
      {
        title: "Actualizar Deuda »",
        icon: "fa fa-pen-square me-2",
        subDrop: [
          {
            title: "Actividades Economicas",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 2,
            subDrop: null,
          },
          {
            title: "Inmuebles Urbanos",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 3,
            subDrop: null,
          },
          {
            title: "Impuestos de Vehiculos",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 4,
            subDrop: null,
          },
          {
            title: "Rentas Inmobilarias",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 5,
            subDrop: null,
          },
          {
            title: "Apuestas Licitas",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 6,
            subDrop: null,
          },
          {
            title: "Propaganda y Publicidad Comercial",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 7,
            subDrop: null,
          },
          {
            title: "Renta de Licores",
            icon: "fas fa-hand-holding-usd me-2",
            itemClickValue: 8,
            subDrop: null,
          },
        ],
      },
      {
        title: "Verificación de Pagos Web",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 9,
      },

      {
        title: "Solvencias Municipales »",
        icon: "fa fa-user-plus me-2",
        subDrop: [
          {
            title: "Solicitudes de Solvencia",
            icon: "fa fa-map me-2",
            itemClickValue: 10,
            subDrop: null,
          },
          {
            title: "Impresión de Solvencias Municipales",
            icon: "fa fa-map me-2",
            itemClickValue: 11,
            subDrop: null,
          },
        ],
      },
      {
        title: "Consulta General de Deudas",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 1,
      },
    ],
  };

  const itamMultas = {
    title: "Multas",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "Clasificador de Multas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 12,
      },
      {
        title: "Actulizar Multas »",
        icon: "far fa-file-powerpoint me-2",
        subDrop: [
          {
            title: "Actividades Economicas",
            icon: "fas fa-file-invoice-dollar me-2",
            itemClickValue: 13,
            subDrop: null,
          },
          // {
          //   title: "Inmuebles Urbanos",
          //   icon: "fas fa-file-invoice-dollar me-2",
          //   itemClickValue: 14,
          //   subDrop: null,
          // },
          // {
          //   title: "Impuestos de Vehiculos",
          //   icon: "fas fa-file-invoice-dollar me-2",
          //   itemClickValue: 15,
          //   subDrop: null,
          // },
          // {
          //   title: "Rentas Inmobilarias",
          //   icon: "fas fa-file-invoice-dollar me-2",
          //   itemClickValue: 16,
          //   subDrop: null,
          // },
          // {
          //   title: "Apuestas Licitas",
          //   icon: "fas fa-file-invoice-dollar me-2",
          //   itemClickValue: 17,
          //   subDrop: null,
          // },
          // {
          //   title: "Propaganda y Publicidad Comercial",
          //   icon: "fas fa-file-invoice-dollar me-2",
          //   itemClickValue: 18,
          //   subDrop: null,
          // },
          {
            title: "Renta de Licores",
            icon: "fas fa-file-invoice-dollar me-2",
            itemClickValue: 19,
            subDrop: null,
          },
        ],
      },
    ],
  };
  const itemReportes = {
    title: "Imprimir",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Resumen de Caja",
        icon: "fas fa-print me-2",
        itemClickValue: 20,
      },
      {
        title: "Ejecución de Presupuesto de Ingreso",
        icon: "fas fa-print me-2",
        itemClickValue: 21,
      },
      {
        title: "Resumen de Ingresos Propios",
        icon: "fas fa-print me-2",
        itemClickValue: 22,
      },
      {
        title: "Transacciones Diarias",
        icon: "fas fa-print me-2",
        itemClickValue: 23,
      },
      {
        title: "Transacciones por Tipo de Impuesto",
        icon: "fas fa-print me-2",
        itemClickValue: 24,
      },
      {
        title: "Listado Deuda de Contribuyentes »",
        icon: "fas fa-hand-holding-usd me-2",
        subDrop: [
          {
            title: "Actividades Economicas",
            icon: "fas fa-print me-2",
            itemClickValue: 25,
            subDrop: null,
          },
          {
            title: "Inmuebles Urbanos",
            icon: "fas fa-print me-2",
            itemClickValue: 26,
            subDrop: null,
          },
          {
            title: "Impuestos de Vehiculos",
            icon: "fas fa-print me-2",
            itemClickValue: 27,
            subDrop: null,
          },
          {
            title: "Rentas Inmobilarias",
            icon: "fas fa-print me-2",
            itemClickValue: 28,
            subDrop: null,
          },
          {
            title: "Apuestas Licitas",
            icon: "fas fa-print me-2",
            itemClickValue: 29,
            subDrop: null,
          },
          {
            title: "Propaganda y Publicidad Comercial",
            icon: "fas fa-print me-2",
            itemClickValue: 30,
            subDrop: null,
          },
          {
            title: "Renta de Licores",
            icon: "fas fa-print me-2",
            itemClickValue: 31,
            subDrop: null,
          },
        ],
      },
      {
        title: "Verificaciones de Pagos On-Line »",
        icon: "fas fa-hand-holding-usd me-2",
        subDrop: [
          {
            title: "Pagos On-Line Rechazados",
            icon: "fas fa-print me-2",
            itemClickValue: 32,
            subDrop: null,
          },
        ],
      },
      {
        title: "Ingresos x Tipos de ingresos",
        icon: "fas fa-print me-2",
        itemClickValue: 33,
        subDrop: null,
      },
    ],
  };
  const resumenGrafica = {
    title: "Analisis Grafico",
    icon: "fa fa-chart-pie me-2",

    drop: [
      {
        title: "RESUMEN Y ANALISIS GRAFICO",
        icon: "fas fa-screwdriver me-2",
        itemClickValue: 116,
      },
      {
        title: "GRAFICOS DE ACTIVIDADES",
        icon: "fas fa-screwdriver me-2",
        itemClickValue: 117,
      },
    ],
  };
  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
             @keyframes float {
               0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
               50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
               100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
             }
             .tech-dot {
               position: absolute;
               background: white;
               border-radius: 50%;
               animation: float 6s infinite ease-in-out;
             }
           `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                   radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                   radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                   ${azulProfundo}
                 `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                   linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "80%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={ImgGestionComercial}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };

  const vista = {
    0: <PorDefecto />,
    1: <TablaConsultaDeudaGenral show={() => setTabla(0)} />,
    2: <TablaActualizarDeuda tipo="comercio" />,
    3: <TablaActualizarDeuda tipo="inmueble" />,
    4: <TablaActualizarDeuda tipo="vehiculo" />,
    5: <TablaActualizarDeuda tipo="rentas" />,
    6: <TablaActualizarDeuda2 tipo="apuesta" />,
    7: <TablaActualizarDeuda2 tipo="publicidad" />,
    8: <TablaActualizarDeuda2 tipo="licores" />,
    9: <TablaVerificacion setTabla={setTabla} />,
    10: <TablaSolicitudSolvencia show={() => setTabla(0)} />,
    11: (
      <TablaConsultaGeneralDeudas show={() => setTabla(0)} solvencia={true} />
    ),
    12: <TablaClasificadorMultas setTabla={() => setTabla(0)} />,
    13: <TablaAsignarMulta tipo="comercio" setTabla={setTabla} />,
    14: <TablaAsignarMulta tipo="inmueble" setTabla={setTabla} />,
    15: <TablaAsignarMulta tipo="vehiculo" setTabla={setTabla} />,
    16: <TablaAsignarMulta tipo="rentas" setTabla={setTabla} />,
    17: <TablaAsignarMulta tipo="apuesta" setTabla={setTabla} />,
    18: <TablaAsignarMulta tipo="publicidad" setTabla={setTabla} />,
    19: <TablaAsignarMulta tipo="licores" setTabla={setTabla} />,
    30: <ImpporDeuda show={show} setShow={setShow} tabla={tabla} />,
    32: (
      <ModalImprimirPagosRechazados show={show} setTabla={() => setTabla(0)} />
    ),
    116: <AnalisisModuloGestionCom />,
    117: <GraficasActividad />,
    33: <ModalIngresosActividad show={show} setTabla={() => setTabla(0)} />,
  };

  return (
    user && (
      <div className="w-100 col-12 m-0 p-0">
        <ImpDeudaGeneralActiEco
          show={mostrarActi}
          onHideCancela={() => {
            (setMostrarActi(false), setTabla(0));
          }}
        />

        <ImpDeudaGeneralInm
          show={mostrarInmu}
          onHideCancela={() => {
            (setMostrarInmu(false), setTabla(0));
          }}
        />

        <ImpModalCaja
          operacion={
            tabla.toString() === "20"
              ? 2
              : tabla.toString() === "23"
                ? 3
                : tabla.toString() === "24"
                  ? 6
                  : 0
          }
          show={mostrarCaja}
          onHideCancelar={() => {
            (setMostrarCaja(false), setTabla(0));
          }}
        />

        <ImprimirEstadoFinancieroPresupuesto
          show={mostrarPresu}
          onHideCancela={() => {
            (setMostrarPresu(false), setTabla(0));
          }}
        />

        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item item={itemCobranzas} setTabla={setTabla} setShow={setShow} />
          <Item item={itamMultas} setTabla={setTabla} setShow={setShow} />
          <Item item={resumenGrafica} setTabla={setTabla} setShow={setShow} />
          <Item item={itemReportes} setTabla={setTabla} setShow={setShow} />
          <a
            href="/haciendaMunicipal"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        <section
          className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
          style={{ height: "90dvh" }}
        >
          {vista[tabla]}
        </section>
        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
      </div>
    )
  );
}
export default MenuPrincipalGestionComercial;
